import { STATUS } from "#candidate/constants"
import { useRefreshCandidate } from "#candidate/redux/actions"
import { useCandidateRedux } from "#candidate/redux/slice"
import { candidateIdPut } from "#candidate/services/api"
import PERMISOS from "#constants/perfiles"
import { DialogMaster } from "#core/components/dialog/Dialog"
import InputSelect from "#core/components/input/select/InputSelect"
import { MainDetailsCommonContainerItems } from "#core/components/main-details/MainDetailsCommon"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import { UseHasPermission } from "#hooks/useHasPermission"
import { Box, Button, Divider, Stack, TextField, Typography } from "@mui/material"
import { colaboradorIdGet } from "modules/colaborador/services/api"
import { Fragment, useCallback, useMemo, useState } from "react"

export default function CandidateStatusCollaborator() {
	const isRh = UseHasPermission(PERMISOS.RH)
	const { candidateId, candidate } = useCandidateRedux()

	const params = useMemo(
		() => ({
			id: candidate.colaborador,
			params: {
				fields: [
					"email",
					"nombre",
					"apellido_materno",
					"apellido_paterno",
					"sucursal",
					"jefe_directo",
					"realiza_cursos",
					"perfil_puesto",
					"url_photo",
					"sexo",
				],
			},
		}),
		[candidateId],
	)
	const { data, loading } = useApi(colaboradorIdGet, { params, autoFetch: true })
	const [open, setOpen] = useState(false)
	const [dataSend, setDataSend] = useState({
		permissions: "Colaborador",
		status: STATUS.COLLABORATOR,
	})
	const [disabled, setDisabled] = useState(false)
	console.log("data colaborador", data)
	const { refresh } = useRefreshCandidate()

	const success = () => {
		setOpen(false)
		refresh()
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(candidateIdPut, { success, end })

	const handleFetch = useCallback(() => {
		setDisabled(true)
		fetch(candidateId, dataSend)
	}, [candidateId, dataSend, fetch])

	if (!isRh) return null

	if (loading) return <Typography>Cargando datos del colaborador...</Typography>

	const info = [
		{ label: "Nombre", value: data.full_name },
		{ label: "perfil puesto", value: data.perfil_puesto },
		{ label: "sucursal", value: data.sucursal },
		{ label: "Jefe directo", value: data.jefe_directo },
		{ label: "Email", value: data.email || "Sin Asignar" },
		// { label: "Realiza cursos", value: data.realiza_cursos ? "Si" : "No" },
	]
	const infoElements = info.map((item) => (
		<Box flex="1 1 auto" minWidth={"200px"} maxWidth={"200px"} key={item.label}>
			<MainDetailsCommonContainerItems label={item.label} value={item.value} />
		</Box>
	))

	return (
		<Fragment>
			<Button onClick={() => setOpen(!open)}>Colaborador</Button>
			<DialogMaster
				open={open}
				setOpen={setOpen}
				maxWidth="sm"
				title="Colaborador"
				handleSubmit={handleFetch}
				disabled={disabled}
			>
				<Box
					display={"flex"}
					gap={1}
					flexWrap="wrap"
					flexDirection={{ xs: "column", sm: "row" }}
					justifyContent="left"
				>
					{infoElements}
					<Divider />

					<TextField
						label="No de Empleado"
						fullWidth
						value={dataSend?.no_empleado}
						onChange={(e) => setDataSend({ ...dataSend, no_empleado: e.target.value })}
					/>
					<InputSelect
						label="Permisos"
						options={[{ label: "Gerente" }, { label: "RH" }, { label: "Colaborador" }]}
						optionsId={"label"}
						optionsLabel={"label"}
						value={dataSend?.permissions}
						setValue={(permissions) => setDataSend({ ...dataSend, permissions })}
					/>
				</Box>
			</DialogMaster>
		</Fragment>
	)
}
